export default __webpack_public_path__ + "static/media/search.inline.8326c7c3.svg";